import React, { useEffect, useRef, useState } from "react";
import SignatureCanvas from "react-signature-canvas";
import { makeStyles } from "@material-ui/core/styles";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { invokeApi } from "../../../bl_libs/invokeApi";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightRegular,
  },
}));

function Agreement(props) {
  const {
    requestData,
    documents,
    SendSignaturePDF,
    showErrorSnak,
    agreementStatus,
    amount,
  } = props;

  const { final_amount } = requestData;

  const classes = useStyles();

  const signPad = React.useRef();

  const [isChecked, setIsChecked] = useState(false);

  const handleClick = () => {
    if (isChecked === false) {
      showErrorSnak("Please checked: Agree to terms and conditions.");
      return;
    }

    if (signPad.current.isEmpty()) {
      showErrorSnak("Please take signature on sign-pad");
      return;
    }
    console.log(signPad, "SIGN_PAD", signPad.current.isEmpty());

    const signature = signPad.current.getCanvas().toDataURL("image/png");

    SendSignaturePDF(signature);

    if (isChecked === false) return;
    // document.getElementById("close-agreement").click();
    // setIsAgree(true);
  };

  const handleRetakeSignature = () => {
    console.log(signPad.current.clear());
  };

  return (
    <>
      <div>
        <div className="" role="document">
          <div className="rounded-box pb-30">
            <div className="modal-header text-center border-0 pb-0"></div>
            <div className="form-wrapper pl-4 pr-4 pl-sm-5 pr-sm-5">
              <div className="modal-body pt-40">
                <h5
                  className="text-center"
                  id="agreement-title"
                  onClick={() => {}}
                >
                  Agreement
                </h5>

                <div className="row pt-1 agreement-separator no-gutters">
                  {agreementStatus !== 0 && (
                    <>
                      <div className="col-12">
                        <Accordion>
                          <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                          >
                            <div className="insurance_btn_text sub-title">
                              Agreement for Moving Services
                            </div>
                          </AccordionSummary>
                          <AccordionDetails>
                            <div
                              dangerouslySetInnerHTML={{
                                __html: documents.Agreement_for_Moving_Services,
                              }}
                              style={{ width: "100%" }}
                            ></div>
                          </AccordionDetails>
                        </Accordion>
                      </div>

                      <div className="col-12 pt-3">
                        <Accordion>
                          <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                          >
                            <div className="insurance_btn_text sub-title">
                              Important Information Booklet
                            </div>
                          </AccordionSummary>
                          <AccordionDetails>
                            <div
                              dangerouslySetInnerHTML={{
                                __html: documents.Important_Information_Booklet,
                              }}
                              style={{ width: "100%" }}
                            ></div>
                          </AccordionDetails>
                        </Accordion>
                      </div>
                    </>
                  )}
                  {agreementStatus === 0 && (
                    <>
                      <div className="col-12 pt-3">
                        <Accordion>
                          <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                          >
                            <div className="insurance_btn_text sub-title">
                              Valuation Declaration
                            </div>
                          </AccordionSummary>
                          <AccordionDetails>
                            <div
                              dangerouslySetInnerHTML={{
                                __html: documents.Valuation_Declaration,
                              }}
                              style={{ width: "100%" }}
                            ></div>
                          </AccordionDetails>
                        </Accordion>
                      </div>

                      <div className="col-12 pt-3">
                        <Accordion>
                          <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                          >
                            <div className="insurance_btn_text sub-title">
                              Issuance of Agreement for Moving Services
                            </div>
                          </AccordionSummary>
                          <AccordionDetails>
                            <div
                              dangerouslySetInnerHTML={{
                                __html:
                                  documents.Issuance_of_Agreement_for_Moving_Services,
                              }}
                              style={{ width: "100%" }}
                            ></div>
                          </AccordionDetails>
                        </Accordion>
                      </div>
                      <div className="col-12 pt-3">
                        <Accordion>
                          <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                          >
                            <div className="insurance_btn_text sub-title">
                              Terms and Conditions
                            </div>
                          </AccordionSummary>
                          <AccordionDetails>
                            <div
                              dangerouslySetInnerHTML={{
                                __html: documents.Terms_and_Conditions,
                              }}
                              style={{ width: "100%" }}
                            ></div>
                          </AccordionDetails>
                        </Accordion>
                      </div>
                    </>
                  )}
                </div>

                <div className="form-check">
                  {/* <input
                    type="checkbox"
                    className="form-check-input"
                    id="exampleCheck1"
                    checked={isChecked}
                    onChange={() => setIsChecked(!isChecked)}
                  />
                  <label className="form-check-label" htmlFor="exampleCheck1">
                    Agree to terms and conditions
                  </label> */}
                  <label className="mb-0 custom-checkbox-wrapper">
                    Agree to terms and conditions
                    <input
                      id="isStorage"
                      type="checkbox"
                      name="storage"
                      checked={isChecked}
                      onChange={() => setIsChecked(!isChecked)}
                    />
                    <span className="custom-check-box"></span>
                  </label>
                </div>
                {agreementStatus !== 0 && (
                  <div className="row pt-2 pt-3">
                    <div className="col text-center">
                      <span className="dark-grey-color">Final Price: </span>{" "}
                      &nbsp;$
                      {amount ? amount : final_amount}
                    </div>
                  </div>
                )}
                <div className="row justify-content-center pt-20 pb-40">
                  <div className="col-12 text-center">
                    <SignatureCanvas
                      ref={signPad}
                      penColor="black"
                      canvasProps={{
                        width:
                          window.innerWidth < 800
                            ? window.innerWidth * 0.7
                            : window.innerWidth * 0.5,
                        height: 250,
                        style: {
                          border: "dashed 1px black",
                        },
                      }}
                    />
                  </div>
                  <div className="col-12 text-center pt-2">
                    <span
                      className="custom-link pointer-point mr-40"
                      onClick={handleRetakeSignature}
                    >
                      Clear Signature Pad
                    </span>
                  </div>
                  <div className="col-12 col-sm-6 col-md-4 pb-40">
                    <button
                      type="button"
                      className="red-btn custom-buton custom-buton-large w-100 mt-40"
                      onClick={handleClick}
                    >
                      DONE
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Agreement;
